let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4SNC8")).then(() => parcelRequire('kIBLO'));